import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g stroke="#383838" strokeLinecap="square">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M14.478 7.091c0 5.33-5.334 8.528-6.4 8.528-1.067 0-6.4-3.198-6.4-8.528a6.399 6.399 0 0 1 6.4-6.396c3.534 0 6.4 2.864 6.4 6.396Z"
      />
      <path d="M8.079 9.223a2.133 2.133 0 1 0 0-4.267 2.133 2.133 0 0 0 0 4.267Z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconPin = memo(ForwardRef);
export default IconPin;
